'use client'

import { useSyncExternalStore } from 'react'
import { ASSETS_GRID_NAVIGATION_EVENT, getGridNavigationTransition } from '@/lib/assets/grid-navigation-transition'

function subscribe(onChange: () => void) {
  window.addEventListener(ASSETS_GRID_NAVIGATION_EVENT, onChange)
  return () => window.removeEventListener(ASSETS_GRID_NAVIGATION_EVENT, onChange)
}

function getSnapshot() {
  const transition = getGridNavigationTransition()
  return transition?.stage === 'loading' ? transition.destination ?? null : null
}

export function useGridNavigationLoadingDestination() {
  return useSyncExternalStore(subscribe, getSnapshot, () => null)
}

export function matchesGridNavigationDestination(href: string, destination: string | null) {
  if (!destination || typeof window === 'undefined') return false
  const url = new URL(href, window.location.href)
  return `${url.pathname.replace(/\/$/, '')}${url.search}` === destination
}

export function useGridNavigationLoading() {
  return useSyncExternalStore(
    subscribe,
    () => getGridNavigationTransition()?.stage === 'loading',
    () => false
  )
}
